import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/scenes/{id}/processing-status', 'get'>;
type ResponseBody = OASOutput<O, '/api/scenes/{id}/processing-status', 'get'>;

type Params = {
  sceneId: number;
};

type Result = {
  id: number;
  guid: string;
  name: string;
  hasProcessingFinishedSuccessfully: boolean | null;
};

export const getSceneProcessingStatusFactory = (apiClient: ApiClient) => {
  const getSceneProcessingStatus = async (variables: Params) => {
    const requestParams = mapInputToRequestParams(variables);
    const response = await apiClient['/api/scenes/{id}/processing-status'].get(requestParams);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      params: {
        id: input.sceneId,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      guid: response.guid,
      name: response.name,
      hasProcessingFinishedSuccessfully: response.hasProcessingFinishedSuccessfully ?? null,
    };
  };

  return getSceneProcessingStatus;
};
